//React
import React from "react";

//UI
import { Input as AntDInput } from "antd";

//CSS
import "./styles/input.css";


const Input = (props) => {
  return <AntDInput className="custom-input" {...props} />;
};

export default Input;
